import axios from "axios";

const API_URL = process.env.VUE_APP_ROOT_API;

class Service {
  async getSchoolList() {
    return await axios
      .get(API_URL + `/school?sort=name&order=asc&filter=active`)
      .then((res) => {
        return res.data;
      });
  }

  async getSuburbList() {
    return await axios
      .get(API_URL + `/code_area?sort=name&order=asc&filter=active`)
      .then((res) => {
        return res.data;
      });
  }

  async getResultsByDestination(destination) {
    return await axios
      .get(API_URL + `/trip?filter=search&destination=${destination}`)
      .then((res) => {
        return res.data;
      });
  }

  async getResultsBySchoolSuburb(school, suburb) {
    const params = `?filter=search&school_id=${school}&area_id=${suburb}`;
    return await axios.get(API_URL + "/trip" + params).then((res) => {
      if (res.data.length < 1) {
        // No School and Trip results so search other table.
        return axios.get(API_URL + "/school_area" + params).then((res) => {
          if (res.data.length > 0 && "url" in res.data[0] && res.data[0].url) {
            window.location = res.data[0].url; // has a URL to redirect
            return []; // so no error is shown
          }
        });
      } else {
        return res.data;
      }
    });
  }
}

export default new Service();
